import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-text-dark bg-primary-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedApproaches data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsItFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}